module.exports = __webpack_public_path__ + "static/assets/35c338ca60869c6e4d21ac52cfce8e69.png";